<template>
  <div class="seleccionar-cliente-wrapper">
    <template v-if="isUpdating">
      <v-progress-linear
        absolute
        color="#6366f1"
        height="4"
        indeterminate
        class="top-progress-bar"
      ></v-progress-linear>
    </template>

    <!-- Fondo superior y banner con v-img -->
    <v-img
      height="230"
      src="/images/background/fondo.jpg"
      class="hero-banner-vimg"
    >
      <div
        class="hero-overlay-dark fill-height d-flex flex-column align-center justify-start text-center pt-6 pb-8 px-4"
      >
        <div class="hero-brand-pill mb-2">
          <v-icon small color="#818cf8" class="mr-2">mdi-shield-check</v-icon>
          <span>Panel de Acceso Seguro</span>
        </div>
        <h1 class="hero-title mb-1">
          {{ hello }}
        </h1>
        <p class="hero-subtitle mb-0">
          {{ message }}
        </p>
      </div>
    </v-img>

    <!-- Contenedor Principal Flotante -->
    <v-container class="selector-container">
      <v-row justify="center">
        <v-col cols="12" sm="10" md="8" lg="6">
          <div class="glass-selector-card pa-6 pa-sm-8">
            <!-- Filtro de Estado: Activos / Inactivos (Admin) -->
            <div
              class="d-flex justify-center mb-5"
              v-if="mostraropcionesclientes"
            >
              <v-btn-toggle
                v-model="activo"
                mandatory
                group
                @change="onClientes"
                class="status-filter-toggle"
              >
                <v-btn
                  :value="1"
                  small
                  active-class="status-btn-active--success"
                  class="status-filter-btn"
                >
                  <v-icon left x-small>mdi-check-circle</v-icon> Activos
                </v-btn>
                <v-btn
                  :value="0"
                  small
                  active-class="status-btn-active--danger"
                  class="status-filter-btn"
                >
                  <v-icon left x-small>mdi-close-circle</v-icon> Inactivos
                </v-btn>
              </v-btn-toggle>
            </div>

            <!-- Formulario de Selección -->
            <v-form @submit.prevent="onFormSubmit()">
              <v-autocomplete
                ref="autocompleteInput"
                v-model="clienteSeleccionado"
                :search-input.sync="searchClienteText"
                :disabled="isUpdating || loadingClientes"
                :items="clientes"
                :loading="loadingClientes"
                outlined
                dark
                color="#6366f1"
                :placeholder="
                  isAdminRole
                    ? 'Ingrese el nombre o RUC de la empresa, o el nombre de un usuario.'
                    : 'Escriba el nombre o RUC de la empresa.'
                "
                prepend-inner-icon="mdi-office-building-marker"
                item-text="name"
                item-value="name"
                :filter="customFilter"
                clearable
                class="custom-autocomplete mb-3"
                attach
                :menu-props="{
                  offsetY: true,
                  nudgeBottom: 8,
                  auto: false,
                  maxHeight: 320,
                  contentClass: 'custom-autocomplete-menu',
                }"
              >
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-item-content
                      v-text="data.item"
                    ></v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-avatar
                      size="40"
                      class="my-1 mr-3 avatar-border"
                    >
                      <v-img
                        v-if="data.item.imagen"
                        :src="data.item.imagen"
                        alt="Logo"
                      ></v-img>
                      <v-avatar v-else color="#334155" size="40">
                        <v-icon small color="#818cf8"
                          >mdi-office-building</v-icon
                        >
                      </v-avatar>
                    </v-list-item-avatar>
                    <v-list-item-content style="min-width: 0">
                      <v-list-item-title
                        class="client-item-title font-weight-bold"
                        style="white-space: normal; word-break: break-word"
                        v-html="data.item.name"
                      ></v-list-item-title>
                      <v-list-item-subtitle
                        class="client-item-subtitle mt-1"
                        style="white-space: normal; word-break: break-all"
                      >
                        <span class="ruc-tag">RUC: {{ data.item.ruc }}</span>
                        <span v-if="data.item.slug" class="slug-tag ml-2">{{
                          data.item.slug.toUpperCase()
                        }}</span>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle
                        v-if="
                          isAdminRole &&
                          getUsuariosCoincidentes(data.item).length > 0
                        "
                        class="client-item-users mt-1"
                        style="white-space: normal; word-break: break-word"
                      >
                        <v-icon x-small color="#4f46e5" class="mr-1"
                          >mdi-account-search</v-icon
                        >
                        <span class="user-match-label mr-1">Usuario:</span>
                        <span
                          v-for="(usuario, idx) in getUsuariosCoincidentes(
                            data.item,
                          )"
                          :key="usuario.id"
                          class="user-tag"
                        >
                          {{ usuario.name
                          }}<span
                            v-if="
                              idx <
                              getUsuariosCoincidentes(data.item).length - 1
                            "
                            >,
                          </span>
                        </span>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>

              <!-- Vista previa destacada del cliente seleccionado -->
              <v-expand-transition>
                <div
                  v-if="clienteObjetoSeleccionado"
                  class="client-preview-card pa-4 rounded-xl mb-5"
                >
                  <div class="d-flex align-center">
                    <v-avatar size="48" class="mr-3 preview-avatar">
                      <v-img
                        v-if="clienteObjetoSeleccionado.imagen"
                        :src="clienteObjetoSeleccionado.imagen"
                      ></v-img>
                      <v-icon v-else color="#10b981" large
                        >mdi-office-building</v-icon
                      >
                    </v-avatar>
                    <div class="flex-grow-1 overflow-hidden">
                      <div class="d-flex align-center">
                        <span class="preview-badge mr-2">Seleccionado</span>
                        <span
                          v-if="clienteObjetoSeleccionado.slug"
                          class="preview-slug"
                        >
                          {{ clienteObjetoSeleccionado.slug }}
                        </span>
                      </div>
                      <div class="preview-name text-truncate mt-1">
                        {{ clienteObjetoSeleccionado.name }}
                      </div>
                      <div class="preview-ruc mt-1">
                        RUC:
                        <strong>{{ clienteObjetoSeleccionado.ruc }}</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </v-expand-transition>

              <!-- Botón de Confirmación -->
              <div class="mt-2">
                <v-btn
                  :loading="loading"
                  :disabled="loading || !clienteSeleccionado"
                  x-large
                  block
                  class="confirm-action-btn"
                  @click="seleccionarcliente()"
                >
                  <span class="btn-text">Confirmar y Acceder</span>
                  <v-icon right class="btn-icon">mdi-arrow-right-circle</v-icon>
                </v-btn>
              </div>
            </v-form>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <MensajeTransicion
      color="#FA694A"
      :text="mensaje"
      v-if="verAlerta"
      :top="true"
      :bottom="false"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import MensajeTransicion from "../components/Alerta.vue";
import Swal from "sweetalert2";

export default {
  name: "SeleccionarCliente",
  components: {
    MensajeTransicion,
  },
  data() {
    return {
      loading: false,
      loadingClientes: false,
      autoUpdate: true,
      clienteSeleccionado: "",
      searchClienteText: "",
      isUpdating: false,
      hello: "Bienvenido a Tiresoft",
      message: "Por favor seleccione el cliente para continuar",
      mensaje: "",
      verAlerta: false,
      clientes: [],
      activo: 1,
      mostraropcionesclientes: false,
    };
  },
  async created() {
    if (localStorage.getItem("role") == 1) {
      this.mostraropcionesclientes = true;
    }
    this.loadRoutes(1);
    this.loadingClientes = true;
    await this.obtenerClientesPorUsuario();
    this.loadingClientes = false;
    this.clientes = this.ClientesUsuario;
    this.onClientes();

    // Mostrar alerta si la BD del cliente seleccionado previamente estaba caída
    const tenantOfflineMessage = sessionStorage.getItem(
      "tenant_offline_message",
    );
    if (tenantOfflineMessage) {
      sessionStorage.removeItem("tenant_offline_message");
      Swal.fire({
        title: "Cliente no disponible",
        text: tenantOfflineMessage,
        icon: "warning",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
      });
    }
  },
  watch: {
    isUpdating(val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 1000);
      }
    },
  },

  methods: {
    ...mapActions("cliente", [
      "obtenerClientesPorUsuario",
      "guardarAccesoACliente",
    ]),
    ...mapActions("navigation", ["loadRoutes"]),

    onClientes() {
      if (this.activo == 1) {
        this.clientes = [];
        this.ClientesUsuario.forEach((element) => {
          if (element.estado == "Activo") {
            this.clientes.push(element);
          }
        });
      } else {
        this.clientes = [];
        this.ClientesUsuario.forEach((element) => {
          if (element.estado == "Inactivo") {
            this.clientes.push(element);
          }
        });
      }
    },

    customFilter(item, queryText) {
      const textOne = item.name ? String(item.name).toLowerCase() : "";
      const textTwo = item.ruc ? String(item.ruc).toLowerCase() : "";
      const textThree = item.slug ? String(item.slug).toLowerCase() : "";
      const searchText = queryText.toLowerCase();

      // Buscar también por nombre de usuario asignado (solo aplica si el objeto tiene usuarios)
      let matchUsuario = false;
      if (this.isAdminRole && item.usuarios && Array.isArray(item.usuarios)) {
        matchUsuario = item.usuarios.some((u) =>
          u.name
            ? String(u.name).toLowerCase().indexOf(searchText) > -1
            : false,
        );
      }

      return (
        textOne.indexOf(searchText) > -1 ||
        textTwo.indexOf(searchText) > -1 ||
        textThree.indexOf(searchText) > -1 ||
        matchUsuario
      );
    },

    getUsuariosCoincidentes(item) {
      if (
        !this.isAdminRole ||
        !item ||
        !item.usuarios ||
        !Array.isArray(item.usuarios)
      ) {
        return [];
      }
      const query = (this.searchClienteText || "").trim().toLowerCase();
      if (!query) {
        return [];
      }
      // Si la búsqueda coincide exactamente con la empresa seleccionada o el nombre/ruc del item actual, no considerarlo como búsqueda de usuario
      if (
        (this.clienteSeleccionado &&
          query === String(this.clienteSeleccionado).trim().toLowerCase()) ||
        (item.name && query === String(item.name).trim().toLowerCase()) ||
        (item.ruc && query === String(item.ruc).trim().toLowerCase())
      ) {
        return [];
      }
      return item.usuarios.filter((u) => {
        return u && u.name && String(u.name).toLowerCase().includes(query);
      });
    },

    onFormSubmit() {
      if (this.clienteSeleccionado) {
        if (this.$refs.autocompleteInput) {
          this.$refs.autocompleteInput.isMenuActive = false;
          if (typeof this.$refs.autocompleteInput.blur === "function") {
            this.$refs.autocompleteInput.blur();
          }
        }
        this.seleccionarcliente();
      }
    },

    seleccionarcliente: async function () {
      if (this.$refs.autocompleteInput) {
        this.$refs.autocompleteInput.isMenuActive = false;
        if (typeof this.$refs.autocompleteInput.blur === "function") {
          this.$refs.autocompleteInput.blur();
        }
      }
      let idCliente = null;
      this.clientes.forEach((element) => {
        if (element.name == this.clienteSeleccionado) {
          idCliente = element.id;
        }
      });
      if (idCliente != null) {
        this.loading = true;
        sessionStorage.setItem("id_cliente_seleccionado", idCliente);
        sessionStorage.setItem("idcliente", idCliente);
        localStorage.removeItem("idcliente");
        localStorage.removeItem("id_cliente_seleccionado");
        localStorage.removeItem("idclient");
        await this.guardarAccesoACliente();
        await this.loadRoutes(1);
        window.location.reload();
        this.loading = false;
      }
    },
  },

  computed: {
    ...mapState("navigation", ["Permisos"]),
    ...mapState("cliente", ["ClientesUsuario"]),
    isAdminRole() {
      const role = localStorage.getItem("role");
      return role == 1 || role == 2;
    },
    clienteObjetoSeleccionado() {
      if (!this.clienteSeleccionado) return null;
      return (
        this.clientes.find((c) => c.name === this.clienteSeleccionado) || null
      );
    },
  },
};
</script>

<style scoped>
/* =========================================================
   UI/UX ENHANCEMENTS - SELECCIONAR CLIENTE
   Slate Dark Theme, Glassmorphism, 44px+ Touch Targets,
   Smooth Micro-transitions & Accessible Typography
   ========================================================= */

.seleccionar-cliente-wrapper {
  min-height: calc(100vh - 49px);
  background: radial-gradient(circle at 50% 15%, #1e293b 0%, #0f172a 100%);
  position: relative;
  overflow-x: hidden;
  padding-bottom: 40px;
}

.top-progress-bar {
  z-index: 10;
}

/* Hero Section */
.hero-banner-vimg {
  position: relative;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.hero-overlay-dark {
  background: linear-gradient(
    180deg,
    rgba(15, 23, 42, 0.6) 0%,
    rgba(15, 23, 42, 0.95) 100%
  );
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  width: 100%;
}

.hero-brand-pill {
  display: inline-flex;
  align-items: center;
  background: rgba(99, 102, 241, 0.15);
  border: 1px solid rgba(99, 102, 241, 0.35);
  padding: 4px 14px;
  border-radius: 9999px;
  color: #c7d2fe;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.hero-title {
  font-size: 32px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.hero-subtitle {
  font-size: 15px;
  color: #94a3b8;
  font-weight: 400;
  max-width: 500px;
  margin: 0 auto;
}

/* Floating Selector Card */
.selector-container {
  margin-top: -65px;
  position: relative;
  z-index: 4;
}

.glass-selector-card {
  background: rgba(30, 41, 59, 0.88);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  box-shadow: 0 20px 45px -10px rgba(0, 0, 0, 0.6),
    0 0 0 1px rgba(255, 255, 255, 0.05);
}

.header-icon-box {
  width: 56px;
  height: 56px;
  background: rgba(99, 102, 241, 0.12);
  border: 1px solid rgba(99, 102, 241, 0.25);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 16px rgba(99, 102, 241, 0.15);
}

.card-heading {
  font-size: 20px;
  font-weight: 700;
  color: #f8fafc;
  margin-bottom: 2px;
}

.card-subheading {
  font-size: 14px;
  color: #94a3b8;
  margin-bottom: 0;
}

/* Status Filter Toggle */
.status-filter-toggle {
  background: rgba(15, 23, 42, 0.6) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  padding: 4px !important;
  border-radius: 9999px !important;
}

.status-filter-btn {
  border-radius: 9999px !important;
  min-height: 34px !important;
  padding: 0 16px !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #94a3b8 !important;
  background: transparent !important;
  border: none !important;
  transition: all 0.2s ease !important;
}

.status-btn-active--success {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.35) !important;
}

.status-btn-active--danger {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.35) !important;
}

/* Input Fields */
.input-label-container {
  display: flex;
  align-items: center;
}

.custom-input-label {
  font-size: 13.5px;
  font-weight: 600;
  color: #cbd5e1;
}

.custom-autocomplete ::v-deep .v-input__control .v-input__slot {
  border-radius: 12px !important;
  background: rgba(15, 23, 42, 0.6) !important;
  border-color: rgba(255, 255, 255, 0.15) !important;
  min-height: 50px !important;
  transition: all 0.25s ease;
  overflow: hidden;
}

.custom-autocomplete ::v-deep .v-progress-linear {
  border-radius: 0 0 12px 12px !important;
  margin: 0 !important;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.custom-autocomplete ::v-deep .v-input__control .v-input__slot:hover {
  border-color: rgba(99, 102, 241, 0.5) !important;
  background: rgba(15, 23, 42, 0.8) !important;
}

.custom-autocomplete ::v-deep.v-input--is-focused .v-input__slot {
  border-color: #6366f1 !important;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.25) !important;
}

/* Client Item in Dropdown */
.client-item-title {
  font-size: 14.5px !important;
  color: #1e293b !important;
}

.client-item-subtitle {
  font-size: 13px !important;
  color: #64748b !important;
}

.ruc-tag {
  color: #475569;
  font-weight: 600;
}

.slug-tag {
  background: #ede9fe;
  color: #6d28d9;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
}

/* User tags in dropdown */
.client-item-users {
  font-size: 11.5px !important;
  color: #4338ca !important;
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  /* background: #eef2ff; */
  /* border: 1px solid #c7d2fe; */
  border-radius: 6px;
  padding: 2px 8px;
  max-width: 100%;
}

.user-match-label {
  font-size: 10.5px;
  font-weight: 700;
  color: #6366f1;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.user-tag {
  font-size: 11.5px;
  color: #3730a3;
  font-weight: 600;
}

/* Selected Client Preview Card */
.client-preview-card {
  background: linear-gradient(
    135deg,
    rgba(16, 185, 129, 0.1) 0%,
    rgba(16, 185, 129, 0.03) 100%
  );
  border: 1px solid rgba(16, 185, 129, 0.4);
  box-shadow: 0 6px 18px rgba(16, 185, 129, 0.1);
  animation: fadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.preview-avatar {
  border: 2px solid rgba(16, 185, 129, 0.5);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
}

.preview-badge {
  background: #10b981;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 1px 7px;
  border-radius: 9999px;
  letter-spacing: 0.04em;
}

.preview-slug {
  background: rgba(255, 255, 255, 0.1);
  color: #6ee7b7;
  font-size: 12px;
  font-weight: 600;
  padding: 1px 6px;
  border-radius: 4px;
}

.preview-name {
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.25;
}

.preview-ruc {
  font-size: 13.5px;
  color: #cbd5e1;
}

/* Confirm Action Button (WCAG 48px touch target) */
.confirm-action-btn {
  min-height: 50px !important;
  border-radius: 12px !important;
  background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%) !important;
  color: #ffffff !important;
  font-size: 15px !important;
  font-weight: 700 !important;
  letter-spacing: 0.02em !important;
  text-transform: none !important;
  box-shadow: 0 6px 20px rgba(79, 70, 229, 0.4) !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.confirm-action-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #4338ca 0%, #4f46e5 100%) !important;
  box-shadow: 0 8px 25px rgba(79, 70, 229, 0.55) !important;
  transform: translateY(-2px);
}

.confirm-action-btn:disabled {
  opacity: 0.5 !important;
  background: #475569 !important;
  box-shadow: none !important;
}

.btn-icon {
  transition: transform 0.2s ease;
}

.confirm-action-btn:hover:not(:disabled) .btn-icon {
  transform: translateX(4px);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 600px) {
  .hero-title {
    font-size: 26px;
  }
  .glass-selector-card {
    padding: 20px 16px !important;
    border-radius: 16px;
  }
  .selector-container {
    margin-top: -40px;
  }
}
</style>

<style>
/* Estilos globales para el menú desplegable del autocomplete */
.custom-autocomplete-menu {
  border-radius: 14px !important;
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.35) !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  max-height: 320px !important;
  overflow-y: auto !important;
}

.custom-autocomplete-menu::-webkit-scrollbar {
  width: 6px;
}

.custom-autocomplete-menu::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.custom-autocomplete-menu::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.custom-autocomplete-menu::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.custom-autocomplete-menu .v-list-item {
  min-height: 48px !important;
  padding: 8px 16px !important;
  transition: background-color 0.2s ease;
}

.custom-autocomplete-menu .v-list-item:hover {
  background-color: #f1f5f9 !important;
}

.custom-autocomplete-menu .v-list-item--active {
  background-color: rgba(99, 102, 241, 0.08) !important;
}
</style>
